import { Observable } from 'rxjs';

import { Progress } from '@daikin-tic/dxone-com-lib';

import { CloudStorage } from '../models/cloud-storage.modal';

export abstract class CloudStorageGateway {
  abstract upload(storage: CloudStorage, body: Blob): Observable<Progress>;
}
